document.addEventListener("DOMContentLoaded", (e) => {
  let industry_sliders = document.querySelectorAll(".industry-slider"),
    industry_slider_wrappers = document.querySelectorAll(
      ".industry-slider__main"
    );

  function reverseChildren(parent) {
    for (var i = 1; i < parent.childNodes.length; i++){
        parent.insertBefore(parent.childNodes[i], parent.firstChild);
    }
  } 

  industry_sliders.forEach((slider) => {
    reverseChildren(slider);
    
    const Flckity_slider = new Flickity(slider, {
      pageDots: false,
      wrapAround: true,
      cellAlign: "center",
      lazyLoad: true,
      on: {
        change: function () {
          const images = [
            this.selectedElement.nextElementSibling?.querySelector("img"),
            this.selectedElement.previousElementSibling?.querySelector("img"),
          ];
          images.forEach((img) => {
            if (img?.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute("data-src");
              img.addEventListener("load", () => {
                window.dispatchEvent(new Event("resize"));
              });
            }
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 1);
          });
        },
      },
    });
  });
  window.dispatchEvent(new Event("resize"));
  setTimeout(() => {
    industry_slider_wrappers.forEach((wrapper) => {
      wrapper.classList.add("hidden");
    });
  }, 1000);
  document
    .querySelector("[data-close-industry-images]")
    .addEventListener("click", (e) => {
      document
        .querySelector(".industry-images__main")
        .classList.add("visibly-hidden");
      industry_slider_wrappers.forEach((wrapper) => {
        wrapper.classList.add("hidden");
        document.querySelector("html").style.overflow = null;
      });
      document
        .querySelector(".grfq-quote-widget-container")
        .classList.remove("slider-active");
    });
});
